module.exports = __webpack_public_path__ + "static/media/single-portfolio-3.8d5d71e4.jpg";